import {
  mapActions,
  mapGetters
} from 'vuex';
import MonCompteI18n from './MonCompte.i18n.js';
import moment from 'moment'

export default {

  components: {},

  props: {},

  computed: {
    ...mapGetters(['user', 'commandes']),
    isPasswordValid() {
      if (this.password1 === '' && this.password2 === '') {
        return null
      } else {
        if (this.password2 === this.password1 && this.password1.length > 7 && this.password2.length > 7) {
          return true
        } else {
          return false
        }
      }
    },
    commandesEnCours() {
      let commandesEnCours = []
      this.commandes.forEach(commande => {
        if (commande.est_annule == 0 && commande.est_expedie == 0) {
          commandesEnCours.push(commande)
        }
      })
      return commandesEnCours
    },
    commandesPassees() {
      let commandesEnCours = []
      this.commandes.forEach(commande => {
        if (commande.est_annule == 1 || commande.est_expedie == 1) {
          commandesEnCours.push(commande)
        }
      })
      return commandesEnCours
    }
  },

  data() {
    return {
      password1: '',
      password2: '',
      isSucces: false,
      errorPassword: false,
      currentCommande: null,
      oldName: ''
    };
  },

  watch: {},

  methods: {
    ...mapActions(['getUserCommandes', 'updateUser', 'updatePassword', 'logout']),
    /**
     * Modale de changement de mot de passe.
     * @param {*} pCommande 
     */
    openModalChangePassword() {
      this.$refs['modal-change-password'].show()
    },
    closeModalPassword() {
      this.$refs['modal-change-password'].hide()
    },
    /**
     * Modale de détail des articles.
     * @param {*} pCommande 
     */
    openModalDetailCommande(pCommande) {
      this.currentCommande = pCommande
      this.$refs['modal-detail-commande'].show()
    },
    closeModalDetailCommande() {
      this.$refs['modal-detail-commande'].hide()
    },
    /**
     * Prix d'une ligne.
     * @param {*} pArticle 
     * @returns 
     */
    getTotalPrixLigne(pArticle) {
      return (pArticle.pivot.quantite * pArticle.pivot.prix_unit * (1 - pArticle.pivot.reduction / 100)).toFixed(2)
    },
    /**
     * Prix d'une commande.
     * @param {*} pCommande 
     * @returns 
     */
    getTotalCommande(pCommande) {
      let total = 0
      pCommande.articles.forEach(article => {
        total = this.getTotalPrixLigne(article) + total
      })
      total = parseFloat(total).toFixed(2)
      return total
    },
    /**
     * Mise à jour de l'utilisateur.
     */
    updateCurrentUser() {
      const user = {
        id: this.user.id,
        name: this.user.name
      }
      this.updateUser(user).then(res => {
        this.oldName = this.user.name
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * Mise à jour du mot de passe.
     */
    updateCurrentPassword() {
      const info = {
        id: this.user.id,
        password: this.password1
      }
      this.updatePassword(info).then(res => {
        this.closeModalPassword()
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * Aller vers le module de management du site.
     */
    goToManagement() {
      this.$router.push('/management')
    },
    /**
     * Déconnexion
     */
    logoutUser() {
      this.logout().then(() => {
        this.$router.push('/')
      })
    }
  },

  filters: {
    formatCurrency(pValue) {
      let formattedNumber = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      }).format(pValue);
      return formattedNumber;
    },
    formatDate(pValue) {
      moment.locale('fr');
      let formattedDate = moment(pValue);
      return formattedDate.format('L');
    }
  },

  mounted() {
    window.scrollTo(0, 0)
    this.getUserCommandes(this.user.id).then(res => {
      this.oldName = this.user.name
    }).catch(err => {
      console.log(err)
    })
  },

  i18n: MonCompteI18n,

};